import React, { useEffect } from 'react';
import SEO from '../../Components/SEO/SEO';
import SdkBanner from '../../Components/SdkBanner/SdkBanner';
import { AboutSdkWrapper, ButtonsGroups, CardBox, CardWrapper } from './style';
import { cardList, cardList2, cardList3, cardList4 } from './Constant';
import Banner from './Banner';
import { isEmpty } from 'lodash';
import mobile1 from '../../assets/images/mobile1.png';
import mobile2 from '../../assets/images/mobile2.png';
import mobile3 from '../../assets/images/mobile3.png';
import userImg from '../../assets/images/userimg1.png';
import userImg2 from '../../assets/images/userimg2.png';
import userImg3 from '../../assets/images/developer-guidance.svg';
import { ListWrapper } from '../../Components/SdkBanner/style';
import DemoButtons from './DemoButtons';

function AboutSdk() {

  useEffect(()=>{
     
  },[]);

	return (
		<AboutSdkWrapper>
			<SEO />
			<div className="bg-white">
				<SdkBanner />

				<div className="container services">
					<h2 class="heading-2 mb70 text-center">
						<span class="strong fs-sm-20">All in one travel services SDK</span>
					</h2>

					<CardBox>
						{cardList.map((card, i) => {
							return <Card card={card} key={i} />;
						})}
					</CardBox>

					<p className="mt40 text-center fs-20 fs-sm-12">
						{' '}
						<strong>24x7 Trusted customer support</strong> to assist and help you in every step of your journey
					</p>
					<div className="center"><DemoButtons /></div>
				</div>

				<section className="section1">
					<div className="container">
					<h2 class="heading-2 mb70 text-center">
						<span class="strong fs-sm-20">Our SDK Perfect For</span>
					</h2>
						<div className="perfectSdk">
							<div className="flex">
								<div>
									<img className='mobileImg' src={mobile1} alt="" />
									<p>Flight Booking</p>
								</div>
								<div>
									<img className='mobileImg' src={mobile2} alt="" />
									<p>Hotel Booking</p>
								</div>
								<div>
									<img className='mobileImg' src={mobile3} alt="" />
									<p>Hotel Booking</p>
								</div>
							</div>

							<p className="fs-20 fs-sm-20 text-center">
								Any product needing <strong>travel features</strong> with minimal dev work
							</p>
							<div className="center"><DemoButtons /></div>

							<CardBox className="layout1 layout2 cardbox2">
								{cardList3.map((card, i) => {
									return <Card card={card} key={i} className="white" />;
								})}
							</CardBox>
						</div>
					</div>
				</section>

				<section className="section2">
					<div className="container mt60">
						<div className="flex box">
							<div className="left">
								<h2 className='fs-sm-20'>What’s Inside</h2>
								<p className='fs-20 fs-sm-12'>Our SDK brings everything you need to launch world-class travel solutions, straight into your app.</p>
								<ListWrapper className='mt80'>
									<li className='fs-sm-12'> Flight Search & Booking </li>
									<li className='fs-sm-12'>Hotel Listings & Reservations</li>
									<li className='fs-sm-12'>Multi-language & Currency Support</li>
									<li className='fs-sm-12'>Dynamic Itinerary Builder </li>
									<li className='fs-sm-12'> Real-Time Price & Availability </li>
									<li className='fs-sm-12'> Secure Payments Integration </li>
								</ListWrapper>
								<img src={userImg2} />
							</div>
							<div className="right">
								<h2 className='fs-sm-20'>Basic Configuration</h2>
								<p className='fs-20 fs-sm-12'>PTM Travel SDK V3 is a powerful React Native SDK that enables seamless integration of travel booking and management features into your application.</p>
								<h3 className='fs-sm-12'>After completing the installation and CLI setup:</h3>
								<ListWrapper>
									<li className='fs-sm-12'> Set up the SDK</li>
									<li className='fs-sm-12'>Initialize the SDK</li>
									<li className='fs-sm-12'>Configure Features</li>
								</ListWrapper>
								<img src={userImg} alt="kkk" />
							</div>
						</div>
					</div>
				</section>

				<section className="section3">
					<div className="container">
						<div className="box">
							<div className="right">
							<h2 class="heading-2 mb20">
						<span class="strong fs-sm-20">Why an SDK, Not APIs?</span>
					</h2>
								<p className=" fs-20 fs-sm-12">
								Unlike traditional APIs that require you to build your own logic, UI, and handle backend complexity, our SDK comes with:
					</p>
							</div>

						</div>
						<div className="cardBox">
						<CardBox className="layout1">
							{cardList2.map((card, i) => {
								return <Card card={card} key={i} className="imgType1 white" />;
							})}
						</CardBox>
					</div>
					</div>

					<div className="container">
					  

						<div className="newBox center">
						  <div className="left center">
							
							 <div>
							 <h4 className="strong fs-sm-12">Latest Release: <br /> Version 1.0.0</h4>
							 <h2 class="heading-2 mb20">
						<span class="strong fs-sm-20">What's New</span>
					</h2>
							 </div>
							 <div className="img">
								<img src={userImg3} alt="developer-guidance" />
							 </div>
						  </div>
						  <div className="right">
							 <ListWrapper>
								<li className='fs-sm-12'>First stable release of PTM Travel SDK V3</li>
								<li className='fs-sm-12'>Complete integration with PTM Travel services</li>
								<li className='fs-sm-12'>  Parent application wallet integration support</li>
								<li className='fs-sm-12'>Support for React Native applications</li>
								<li className='fs-sm-12'>  Comprehensive documentation and examples</li>
								<li className='fs-sm-12'>CLI tool for easy setup and configuration</li>
								<li className='fs-sm-12'> Enhanced security</li>
								<li className='fs-sm-12'>features Real-time transaction support</li>
							 </ListWrapper>
						  </div>
						</div>
 
					

					</div>

					<div className="container">
						<div className="bannerbox">

							<div>
							<h2 class="heading-2 mb20">
						<span class="strong fs-sm-20">Start building better travel experiences today</span>
					</h2>
					<h3 className="fs-20 fs-sm-12">with our SDK-first approach.</h3>
					<DemoButtons />
							</div>

						</div>
					</div>
				</section>


				<div className="container services">
					<h2 class="heading-2 mb70 text-center">
						<span class="strong fs-sm-20">Benefits of Using Our Travel SDK</span>
					</h2>

					<CardBox className="imgType1">
						{cardList4.map((card, i) => {
							return <Card card={card} key={i} className="imgType1 white" />;
						})}
					</CardBox>

					<p className="mt40 text-center fs-20 fs-sm-12">
						{' '}
						<strong>24x7 Trusted customer support</strong> to assist and help you in every step of your journey
					</p>
				</div>

				
			</div>
			
			<Banner />
		</AboutSdkWrapper>
	);
}

export default AboutSdk;

const Card = ({ card = {}, key, className = '' }) => {
	return (
		<CardWrapper className={className} key={key}>
			<div className="img">
				<img src={card.img} alt={card.h3} />
			</div>
			<h3>{card?.h3}</h3>
			{!isEmpty(card?.p) &&<p>{card?.p}</p>}
		</CardWrapper>
	);
};


